import { Page, Spin, Text, Title } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Instructions from './Instructions';
import ListingEditor from './ListingEditor';
import ListingFinder from './ListingFinder';
import TriggerRetsListingUpdatePageContext from './TriggerRetsListingUpdatePageContext';

const TriggerRetsListingUpdatePageContent: React.FC = () => {
  const { boards } = useContext(TriggerRetsListingUpdatePageContext);

  if (!boards.length) return <Spin size="large" center />;

  return (
    <Page type="filled" fillScreenHeight>
      <Layout>
        <Title level={1} hideMargin data-cy="page-title">
          Trigger RETS Listing Update QA Page
        </Title>
        <Text>
          This QA page is used to help trigger RETS update for listings
        </Text>

        <Instructions />
        <ListingFinder />
        <ListingEditor />
      </Layout>
    </Page>
  );
};

export default TriggerRetsListingUpdatePageContent;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 32px;
  padding: 20px;
  background: white;
`;
